import { lazy } from 'react';

const LessonCompletionNoteModal = lazy(() => import('./modals/NoteModal'));
const LessonLibraryModuleOverviewModal = lazy(() =>
  import('./modals/ModuleOverviewModal'),
);

export default {
  LESSON_COMPLETION_NOTE_MODAL: LessonCompletionNoteModal,
  LESSON_LIBRARY_MODULE_OVERVIEW_MODAL: LessonLibraryModuleOverviewModal,
};
